module.exports = __webpack_public_path__ + "img/RTI_CES_W.9ba5b080.svg";